import SubtleBadge from '../../../../components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import ChildrensTooltip from '../../../../components/common/ChildrensTooltip';
import { getAnalysisStatusMeta, hasKnownAnalysisStatus } from '@/app/PageSpeed/utils/analysisStatus';

type AnalysisStatusRendererProps = {
  status?: unknown;
};

const AnalysisStatusRenderer = ({
  status
}: AnalysisStatusRendererProps) => {
  if (!hasKnownAnalysisStatus(status)) {
    return (
      <div className="w-100 d-flex h-100 align-items-center justify-content-center " />
    );
  }
  const meta = getAnalysisStatusMeta(status);
  const showErrorHint = meta.variant === 'danger' && meta.description;

  const statusEl = (
    <SubtleBadge pill bg={meta.variant} className="d-block fs--2">
      <FontAwesomeIcon
        className="me-1"
        icon={meta.icon as IconProp}
        transform="shrink-2"
      />
      {meta.label}
      {showErrorHint ? (
        <FontAwesomeIcon className="mx-1" icon="exclamation-circle" />
      ) : null}
    </SubtleBadge>
  );

  return (
    <div className="w-100 d-flex h-100 align-items-center justify-content-center ">
      {meta.description ? (
        <ChildrensTooltip html={meta.description}>{statusEl}</ChildrensTooltip>
      ) : (
        statusEl
      )}
    </div>
  );
};

export default AnalysisStatusRenderer;
